import { render, staticRenderFns } from "./ThanksStep.vue?vue&type=template&id=2225e299"
import script from "./ThanksStep.vue?vue&type=script&lang=js"
export * from "./ThanksStep.vue?vue&type=script&lang=js"
import style0 from "./ThanksStep.vue?vue&type=style&index=0&id=2225e299&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports